var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7345_27001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0371 0 0 4.0371 0 9C0 13.9629 4.0371 18 9 18C13.9629 18 18 13.9622 18 9C18 4.0378 13.9629 0 9 0ZM9 16.6057C4.80674 16.6057 1.39426 13.194 1.39426 9C1.39426 4.80604 4.80674 1.39426 9 1.39426C13.1933 1.39426 16.6057 4.80604 16.6057 9C16.6057 13.194 13.194 16.6057 9 16.6057Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4854 8.23958H9.69686V5.45105C9.69686 5.06623 9.38524 4.75391 8.99971 4.75391C8.61419 4.75391 8.30257 5.06623 8.30257 5.45105V8.23958H5.51404C5.12852 8.23958 4.81689 8.55191 4.81689 8.93673C4.81689 9.32155 5.12852 9.63387 5.51404 9.63387H8.30257V12.4224C8.30257 12.8072 8.61419 13.1195 8.99971 13.1195C9.38524 13.1195 9.69686 12.8072 9.69686 12.4224V9.63387H12.4854C12.8709 9.63387 13.1825 9.32155 13.1825 8.93673C13.1825 8.55191 12.8709 8.23958 12.4854 8.23958Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7345_27001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/PlusCircle.795253486255bd5f37899d5c33175a84.svg";
export { ForwardRef as ReactComponent };